import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getBranches } from '../redux.actions';

const SelectBranch = ({ getBranches, input: { value, onChange } }) => {
    const [branches, setBranches] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getBranches({
            handleSubmit: (data) => {
                setIsLoading(false);
                if (data && data.data) {
                    // Filter out "-- --"
                    const branchOptions = data.data
                        .filter((branch) => branch.name !== '-- --')
                        .map((branch) => ({
                            name: branch.name,
                            value: branch.name
                        }));
                    setBranches(branchOptions);
                }
            }
        });
    }, [getBranches]);

    // Find the selected branch by value
    const selectedBranch = value
        ? branches.find((b) => String(b.value) === String(value)) || null
        : null;

    return (
        <Autocomplete
            size='small'
            sx={{
                minWidth: 158,
                backgroundColor: theme => theme.palette.common.paper
            }}
            componentsProps={{
                paper: {
                    sx: {
                        '& .MuiAutocomplete-option': {
                            fontSize: '12px'
                        }
                    }
                }
            }}
            options={branches}
            getOptionLabel={(option) => option.name || ''}
            value={selectedBranch}
            onChange={(event, newValue) => {
                onChange(newValue ? newValue.value : null);
            }}
            loading={isLoading}
            disableCloseOnSelect={false}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label='Branch'
                    placeholder='Select branch'
                    sx={{
                        '& .MuiInputBase-input': { fontSize: '12px' },
                        '& .MuiInputLabel-root': { fontSize: '12px' }
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {isLoading ? (
                                    <CircularProgress
                                        color='inherit'
                                        size={20}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
            )}
        />
    );
};

const mapDispatchToProps = (dispatch) => ({
    getBranches: (payload) => dispatch(getBranches(payload))
});

export default connect(null, mapDispatchToProps)(SelectBranch);
